/**
 * Datadog's tracking-consent literal union, re-declared so consumers of this
 * library never need to import SDK types.
 */
export type TTrackingConsent = 'granted' | 'not-granted';

/** Values Osano reports for each cookie category. */
export enum E_OSANO_CONSENT_STATUS {
  ACCEPT = 'ACCEPT',
  DENY = 'DENY',
}

/**
 * The subset of the viewer we send to Datadog: id only, never name or email.
 * See ADR 20261015, "Privacy position".
 */
export interface IRumUser {
  id: string;
}
